import * as React from 'react';
import { Responsive } from 'semantic-ui-react';
import { getI18n } from 'services/i18n-service';
import { OfflineIcon } from 'components/connection-status/offline-icon';
import { Props } from '../props';
import { SuccessStatusIcon } from './success';
import { PendingStatusIcon } from './pending';
import { StatusIconPopup } from './status-icon-popup';
import { translations } from 'types/translations';

import './styles.css';

const spaceChar: string = '\x20';

export class StatusCell extends React.Component<Props> {
  render() {
    let content;
    const i18n = getI18n();
    const operationItem = this.props.operationItem;
    let statusLabel = operationItem.epc.status;
    if (operationItem.epc.status && operationItem.epc.status.startsWith(i18n.t(translations.Pending))) {
      if (!this.props.isOnline) {
        content = <OfflineIcon className="status-cell-content" />;
        statusLabel = i18n.t(translations.AwaitingConnection);
      } else {
        content = <PendingStatusIcon />;
      }
    } else if (operationItem.hasError === true) {
      content = (
        <StatusIconPopup iconName="x" iconColor="red"
          message={i18n.t(translations.CommunicationError) + spaceChar} operationItem={operationItem} />
      );
    } else if (operationItem.hasAlert === true) {
      content = (
        <StatusIconPopup iconName="exclamation triangle" iconColor="orange"
          message={operationItem.alertMessage + spaceChar} operationItem={operationItem} />
      );
    } else {
      content = <SuccessStatusIcon />;
    }

    return (
      <>
        <Responsive maxWidth={Responsive.onlyTablet.maxWidth} as={React.Fragment}>
          <div className="mobile-status-cell">
            {content}<br />
            <span className="status-label">{statusLabel}</span>
          </div>
        </Responsive>
        <Responsive {...Responsive.onlyComputer} as={React.Fragment}>
          {content}
        </Responsive>
      </>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/operation-grid/cells/status/component.tsx